import React from 'react'
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

const CTA = () => {
    return (
        <div>
            {/* Contact Us Section */}
            <section section className="contact-section py-5" >
                <div className="container">
                    <div className="row g-4">

                        {/* Left column (CTA + Map) */}
                        <motion.div
                            className="col-lg-6"
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.7 }}
                        >
                            <div className='row'>
                                <div className='col-md-12 mb-lg-3'>
                                    {/* CTA */}
                                    <div className='cta-section'>
                                        <section className="container text-center">
                                            <h2 className="cta-title mb-4">Visit Us</h2>
                                            <p className="cta-info mb-2"><i className="bi bi-geo-alt-fill"></i> At <strong>J J Empire, Dr. Yagnik Road, Opp Hotel Imperial Palace, Rajkot, 360001</strong></p>
                                            <p className="cta-info mb-2"><i className="bi bi-telephone-fill"></i> Call us: <strong><a href="tel:++912812480490" className="cta-link">(0281) 2480490 / 890</a></strong></p>
                                            <p className="cta-info mb-3"><i className="bi bi-envelope-fill"></i> Email: <strong><a href="mailto:tanishqjjassociates@gmail.com" className="cta-link">tanishqjjassociates@gmail.com</a></strong></p>
                                            <NavLink to="#" className="cta-btn">
                                                Contact Us
                                            </NavLink>
                                        </section>
                                    </div>
                                </div>

                                <div className='col-md-12'>
                                    {/* Map */}
                                    <div className="contact-map">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14766.346681602181!2d70.77467080250476!3d22.293641725058972!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959ca19b92db457%3A0x167f06b852f19bab!2sTanishq%20Jewellery%20-%20Rajkot%20-%20Dr.%20Yagnik%20Road!5e0!3m2!1sen!2sin!4v1759829903346!5m2!1sen!2sin"
                                            width="100%"
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade">
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Right column (Form) */}
                        <motion.div
                            className="col-lg-6"
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.7 }}
                        >
                            <div className="contact-form">
                                <div className="contact-header">
                                    <h5>Get in Touch with Us</h5>
                                    <p>We’d love to hear from you! Fill out the form below and our team will get back to you shortly.</p>
                                </div>

                                <form>
                                    <div className='row'>
                                        <div className="col-md-6 mb-3">
                                            <input type="text" className="form-control" placeholder="Full Name" required />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <input type="email" className="form-control" placeholder="Email Address" required />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <input type="text" className="form-control" placeholder="Phone Number" required />
                                    </div>
                                    <div className="mb-3">
                                        <textarea className="form-control" rows="5" placeholder="Your Message"></textarea>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <button type="submit" className="btn contact-btn">Send Message</button>
                                    </div>
                                </form>
                            </div>
                        </motion.div>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default CTA